module.exports = __webpack_public_path__ + "static/media/bg-bid-winner.6fac384a.png";